import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useSession } from '../useSession';

export const useDefaultRosterStartDate = (): DateTime => {
  const { user } = useSession();
  const defaultRosterStartDate = user?.orgInfo?.defaultRosterStartDate;

  return useMemo(() => {
    if (!defaultRosterStartDate) return DateTime.local();
    const configured = DateTime.fromISO(defaultRosterStartDate);
    return configured.isValid ? configured : DateTime.local();
  }, [defaultRosterStartDate]);
};
